import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AuthHeader from "../auth/AuthHeader/AuthHeader";
import { Box, MainHeading } from "../styled/Elements";
import AppSettingsApi from "../../services/api/appSettingsApi";

const HTML_FIELD_BY_KIND = {
  privacy: "privacy_html",
  terms: "terms_html",
};

/**
 * Renders admin-managed legal HTML from GET /api/v1/app-settings (same source as Flutter).
 */
const LegalCmsPage = ({ kind, titleKey, pageClassName, Wrapper }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const locale = i18n.language === "ar" ? "ar" : "en";

  const [html, setHtml] = useState("");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let cancelled = false;

    const loadLegalContent = async () => {
      setStatus("loading");
      setHtml("");

      const settings = await AppSettingsApi.fetchAppSettings(locale);
      if (cancelled) {
        return;
      }

      if (!settings || settings instanceof Error) {
        setStatus("error");
        return;
      }

      const field = HTML_FIELD_BY_KIND[kind];
      const content = String(settings[field] ?? "").trim();

      if (!content) {
        setStatus("empty");
        return;
      }

      setHtml(content);
      setStatus("success");
    };

    loadLegalContent();

    return () => {
      cancelled = true;
    };
  }, [kind, locale]);

  const renderBody = () => {
    if (status === "loading") {
      return (
        <div className="legal-cms-status text-center py-5">
          <Spinner animation="border" role="status" variant="primary" />
        </div>
      );
    }

    if (status === "error") {
      return (
        <p className="legal-cms-status legal-cms-message">
          {t("legal_load_failed")}
        </p>
      );
    }

    if (status === "empty") {
      return (
        <p className="legal-cms-status legal-cms-message">
          {t("legal_content_unavailable")}
        </p>
      );
    }

    return (
      <div
        className="legal-cms-html"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  };

  return (
    <Box className={pageClassName}>
      <AuthHeader />
      <Container>
        <MainHeading className="text-center mt-5 pt-5">{t(titleKey)}</MainHeading>
        <Wrapper dir={isRTL ? "rtl" : "ltr"}>
          <div className="legal-cms-content">{renderBody()}</div>
        </Wrapper>
      </Container>
    </Box>
  );
};

export default LegalCmsPage;
